import { cx } from "@/utils";

import { useEpisode } from "../../context";

import styles from "./PaywallNotice.module.css";

type PaywallNoticeProps = { className?: string };

const PaywallNotice: React.FunctionComponent<PaywallNoticeProps> = ({
  className,
}) => {
  const { is_paywalled } = useEpisode();

  if (!is_paywalled) return null;
  return (
    <span
      data-testid="episode-paywalled"
      className={cx(styles.root, className)}
    >
      {L.MENTIONS_CONTEXT_PAYWALLED}
    </span>
  );
};

export default PaywallNotice;
